module.exports = __webpack_public_path__ + "img/Find_resumes.b54e92fe.svg";